module.exports = __webpack_public_path__ + "img/ng_3.59b26760.png";